import { Square } from "chess.js"
import { usePuzzle } from "@/hooks/usePuzzle"
import { useEffect, useState } from "react"

const PuzzleBoard = () => {
  const [Board, setBoard] = useState<
    null | (typeof import("chessboardjsx"))["default"]
  >(null)

  useEffect(() => {
    let mounted = true

    import("chessboardjsx").then((mod) => {
      if (mounted) setBoard(() => mod.default)
    })

    return () => {
      mounted = false
    }
  }, [])

  const { position, setPosition, dropSquareStyle, setDropSquareStyle } =
    usePuzzle()

  const onDrop = ({
    sourceSquare,
    targetSquare,
    piece,
  }: {
    sourceSquare: Square | "spare"
    targetSquare: Square
    piece: string
  }) => {
    const newPosition = { ...position }

    if (sourceSquare === "spare") {
      newPosition[targetSquare] = piece
    } else {
      newPosition[targetSquare] = newPosition[sourceSquare]
      delete newPosition[sourceSquare]
    }

    setPosition(newPosition)
  }

  const onDragOverSquare = () =>
    setDropSquareStyle({ boxShadow: "inset 0 0 1px 6px rgb(255, 255, 255)" })

  if (!Board) return null

  return (
    <Board
      getPosition={(latestPosition) => {
        const newPosition = { ...latestPosition }
        setPosition(newPosition)
        return newPosition
      }}
      position={position}
      darkSquareStyle={{
        backgroundColor: "#c56c1a",
      }}
      lightSquareStyle={{
        backgroundColor: "#ffd17f",
      }}
      boardStyle={{
        width: "100%",
      }}
      calcWidth={({ screenWidth }) => Math.min(screenWidth - 50, 500)}
      dropSquareStyle={dropSquareStyle}
      onDragOverSquare={onDragOverSquare}
      dropOffBoard="trash"
      sparePieces={true}
      onDrop={onDrop}
    />
  )
}

export default PuzzleBoard
